import React, { FunctionComponent, memo } from 'react';
import Loader from '../../../../common/components/presentation/Loader';
import ModalWithHeader from '../../../../common/components/presentation/ModalWithHeader';
import Translation from '../../../../common/components/translation/Translation';
import { useGetFinCalcSpcInitConfig } from '../../../../common/react/useGetFinCalcSpcInitConfig';
import { ICarDetails } from '../../../../../../common/model/ICarDetails';
import financeCalculatorContainerStyles from './financeCalculatorContainerStyles';
import FinanceCalculatorCustomiseWidget from './FinanceCalculatorCustomiseWidget';

interface IFinanceCalculatorContainerProps {
  isModalOpen: boolean;
  toggleModal?: (shouldOpen: boolean) => void;
  externalId: string;
  carConfiguration?: ICarDetails;
}

const FinanceCalculatorContainer: FunctionComponent<IFinanceCalculatorContainerProps> = memo(
  ({ isModalOpen, toggleModal, externalId, carConfiguration }) => {
    const styles = financeCalculatorContainerStyles();

    const { isConfigLoading, finCalcSpcInitConfig } = useGetFinCalcSpcInitConfig(
      isModalOpen && !carConfiguration,
      externalId,
    );

    return (
      <ModalWithHeader
        open={isModalOpen}
        toggleModal={toggleModal}
        title={<Translation id="spc.customise.fc.title" />}
        titleProps={{
          'data-test': 'title:fincalc_spc_title',
          id: 'finCalc-spc-title',
        }}
        contentProps={{
          'data-test': 'container:fincalc_configurator',
        }}
        className={styles.finCalc}
      >
        {isConfigLoading && <Loader />}
        {(carConfiguration || finCalcSpcInitConfig.model) && (
          <FinanceCalculatorCustomiseWidget
            carConfiguration={carConfiguration ? carConfiguration : finCalcSpcInitConfig}
            toggleModal={toggleModal}
          />
        )}
      </ModalWithHeader>
    );
  },
);

export default FinanceCalculatorContainer;
